export default __webpack_public_path__ + "static/media/official.ca27ede3.png";